import type { FC } from 'react';
import React, { useMemo } from 'react';

import { BylineAppTriggerVisual } from '@confluence/web-item/entry-points/BylineAppTriggerVisual.ts';

import { isByLineAppSnapshotAuthoritative, type ByLineAppSnapshot } from './byLineAppSnapshot.ts';

export const AuthoritativeByLineApps: FC<{
	snapshot: ByLineAppSnapshot;
}> = ({ snapshot }) => {
	const resolvedApps = useMemo(() => {
		const apps: ByLineAppSnapshot['apps'] = [];
		for (const app of snapshot.apps) {
			if (app.presentation.resolution === 'resolved') {
				apps.push(app);
			}
		}
		return apps;
	}, [snapshot.apps]);

	// Callers gate this renderer behind confluence_ssr_byline.
	if (!isByLineAppSnapshotAuthoritative(snapshot)) {
		return null;
	}

	return (
		<>
			{resolvedApps.map(({ id, presentation, producer }) => (
				<BylineAppTriggerVisual
					data-byline-app-producer={producer}
					data-testid={producer === 'connect' ? 'web-item-link' : 'forge-byline-header-wrapper'}
					key={id}
					title={presentation.tooltip}
				>
					{presentation.icon ? (
						<img
							alt=""
							height={presentation.icon.height}
							src={presentation.icon.src}
							width={presentation.icon.width}
						/>
					) : null}
					{producer === 'connect' ? (
						// Connect web-item labels are already-authoritative server HTML, matching WebItem.
						// eslint-disable-next-line react/no-danger
						<span dangerouslySetInnerHTML={{ __html: presentation.label }} />
					) : (
						presentation.label
					)}
				</BylineAppTriggerVisual>
			))}
		</>
	);
};
